import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const pageMeta = {
  '/dashboard': { title: 'Overview' },
  '/dashboard/global-layout': { title: 'Global Layout' },
  '/dashboard/pages': { title: 'Pages' },
  '/dashboard/pages/solution-details': { title: 'Solution Pages' },
  '/dashboard/pages/market-details': { title: 'Market Pages' },
  '/dashboard/pages/wealth-details': { title: 'Wealth Product Pages' },
  '/dashboard/pages/market-analysis-posts': { title: 'Market Analysis Posts' },
  '/dashboard/account-submissions': { title: 'Account Submissions' },
  '/dashboard/contact-submissions': { title: 'Contact Submissions' },
  '/dashboard/newsletter-subscriptions': { title: 'Newsletter Subscriptions' },
  '/dashboard/partnership-submissions': { title: 'Partnership Submissions' },
  '/dashboard/vps-hosting-requests': { title: 'VPS Hosting Requests' },
  '/dashboard/sections': { title: 'Sections' },
  '/dashboard/content': { title: 'Content' },
  '/dashboard/media': { title: 'Media' },
};

const getPageTitle = (pathname) => {
  if (pageMeta[pathname]) {
    return pageMeta[pathname].title;
  }

  if (pathname.startsWith('/dashboard/pages/')) {
    if (pathname === '/dashboard/pages/solution-details') {
      return 'Solution Pages';
    }

    if (pathname === '/dashboard/pages/market-details') {
      return 'Market Pages';
    }

    if (pathname === '/dashboard/pages/wealth-details') {
      return 'Wealth Product Pages';
    }

    if (pathname === '/dashboard/pages/market-analysis-posts') {
      return 'Market Analysis Posts';
    }

    const slug = pathname.replace('/dashboard/pages/', '');
    if (!slug) {
      return 'Pages';
    }

    return slug
      .split('-')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  if (pathname.startsWith('/dashboard/account-submissions/')) {
    return 'Submission Details';
  }

  if (pathname.startsWith('/dashboard/contact-submissions/')) {
    return 'Contact Message Details';
  }

  if (pathname.startsWith('/dashboard/partnership-submissions/')) {
    return 'Partnership Inquiry Details';
  }

  if (pathname.startsWith('/dashboard/vps-hosting-requests/')) {
    return 'VPS Request Details';
  }

  return pageMeta['/dashboard'].title;
};

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const meta = pageMeta[location.pathname] || { title: getPageTitle(location.pathname) };

  return (
    <div className="flex min-h-screen bg-[#f7f3eb] font-[Montserrat] text-[#130705]">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar title={meta.title} onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
